export default {
    props: {
        listenForHover: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            show: false,
        }
    },

    created() {
        EventBus.$on('AppClick', (event) => {
            if ( ! this.$el.contains(event.target)) {
                this.close();
            }
        });
    },

    methods: {
        toggle() {
            this.show = ! this.show;
        },

        open() {
            this.show = true;
        },

        close() {
            this.show = false;
        },

        triggerClickFromMobileTap (event) {
            try {
                let elem = event.target;
                // Create our event (with options)
                let evt = new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                });
                // If cancelled, don't dispatch our event
                let canceled = !elem.dispatchEvent(evt);
            } catch (error) {
                console.warn ( `Can't duplicate click!` );
            }
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/components/Dropdown.js